<div class="hb-container">
  <kenjo-back-arrow-button *ngIf="(currentProgress$ | async) > 1 && (currentProgress$ | async) < 5"></kenjo-back-arrow-button>
  <kenjo-refresh-button *ngIf="(currentProgress$ | async) === 1"></kenjo-refresh-button>
  <kenjo-progress-bar></kenjo-progress-bar>
  <kenjo-language-picker *ngIf="(currentProgress$ | async) <= 5"></kenjo-language-picker>
</div>
